import React, { useEffect, useState } from 'react';

import FormHeader from 'prequalificationV2/components/FormHeader';
import { CompleteInstantAuthenticationResponse, proveApi } from 'api/ProveApi';
import FormBody from 'components/FormBody';
import Loader from 'components/Loader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { Theme } from 'enums/Theme';
import useQueryParam from 'hooks/useQueryParam';

import styles from './VerificationComplete.module.scss';

const FAILED_VERIFICATION_MESSAGE = 'Verification Failed';
const SUCCESS_VERIFICATION_MESSAGE = 'Verification Complete';

const VerificationComplete = () => {
  const vfp = useQueryParam('vfp');
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const completePhoneVerification = async () => {
      setIsLoading(true);

      if (!!vfp) {
        const response: CompleteInstantAuthenticationResponse = await proveApi.completeInstantAuthentication({
          vfp: vfp,
        });

        setIsError(!response.success);
      } else {
        setIsError(true);
      }

      setIsLoading(false);
    };

    completePhoneVerification();
  }, []);

  const verificationResultTitle = isError ? FAILED_VERIFICATION_MESSAGE : SUCCESS_VERIFICATION_MESSAGE;
  const progressBarStatus = isError ? ProgressBarStatus.Error : ProgressBarStatus.Done;

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <FormHeader title={verificationResultTitle} theme={Theme.Light} percent={progressBarStatus} />
          <FormBody>
            <div className={styles.infoContainer}>
              Please return to the device or tab where you began your loan inquiry to continue.
            </div>
          </FormBody>
        </>
      )}
    </>
  );
};

export default VerificationComplete;
